/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-10-31 10:03:28
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-17 17:37:47
 * @FilePath: \ioc_base\src\modules\realTimeAlarm\router.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const routes = [
  // 实时告警
  {
    path: '/realTimeAlarm',
    name: 'realTimeAlarm',
    // component: () => import('@src/modules/realTimeAlarm/view/RealTimeAlarmNew'),
    component: () => import('@src/modules/realTimeAlarm/view/RealTimeAlarmS'),
    meta: {
      requireAuth: true,
      // routerAlive:true
    }
  },
  // 消防
  {
    path: '/fireManage',
    name: 'fireManage',
    component: () => import('@src/modules/realTimeAlarm/view/FireManageNew'),
    meta: {
      // routerAlive:true
    }
  }
]

export default routes